import React from 'react';
import { rootStore } from '@store/Root.store';

export const StoreContext = React.createContext(rootStore);
export const StoreProvider = StoreContext.Provider;
